module.exports = __webpack_public_path__ + "img/1_018.1b4797eb.jpg";